import { Navigation } from '../../components/Navigation/Navigation';
import { useAuth } from '../../context/Auth';

const AccountNav = () => {
  const { user } = useAuth();

  const navigationPaths = {
    Account: '/account',
    Subscriptions: '/subscriptions',
    ...(user?.profile?.default ? { Payments: '/payments' } : null),
    Support: '/support',
    Contacts: '/contacts',
    Feedback: '/feedback',
    Referral: '/referral',
    PrivacyAndTerms: '/privacy-and-terms',
  };

  return (
    <div className="flex overflow-x-auto justify-start md:justify-center text-sm gap-3">
      {Object.keys(navigationPaths).map((title) => (
        <Navigation
          key={navigationPaths[title]}
          path={navigationPaths[title]}
          className="px-4 py-3"
          activeClassName="border-b-4 border-primary"
        >
          {title}
        </Navigation>
      ))}
    </div>
  );
};

export { AccountNav };
